export default "<p style=\"min-width: 80vw;\">{{ text }}</p>\n"